module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.28773/images/keyFeatures/dataStudio_callout.png"